import RegionSelector from './region-selector';
import * as uiConsts from './consts';

class MainNavigation {
  constructor() {
    this.navigationNode = document.getElementsByClassName('main-navigation')[0];
    this.regionSelector = new RegionSelector();

    this.stickyNav();
  }

  stickyNav() {
    const header = document.querySelector('.header');

    window.addEventListener('scroll', () => {
      if (window.pageYOffset > 0) {
        header.classList.add('sticky');

        if (this.regionSelector.regionFlyout) {
          this.regionSelector.regionFlyout.classList.add(
            uiConsts.COLLAPSE_OPACITY_CLASS
          );
        }
      } else {
        header.classList.remove('sticky');
        
        if (this.regionSelector.regionFlyout) {
          this.regionSelector.regionFlyout.classList.remove(
            uiConsts.COLLAPSE_OPACITY_CLASS
          );
        }
      }
    });
  }
}

export default MainNavigation;
